import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FullNamePipe } from './pipes/full-name.pipe';
import { FullAddressPipe } from './pipes/full-address.pipe';
import { StaffFullNamePipe } from './pipes/staff-full-name.pipe';

@NgModule({
  declarations: [FullNamePipe, FullAddressPipe, StaffFullNamePipe],
  imports: [CommonModule],
  exports: [FullNamePipe, FullAddressPipe, StaffFullNamePipe]
})
export class NameModule { }
